import { render, staticRenderFns } from "./mainSafetyHealthyMstPopup.vue?vue&type=template&id=25fd0372"
import script from "./mainSafetyHealthyMstPopup.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyMstPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fd0372')) {
      api.createRecord('25fd0372', component.options)
    } else {
      api.reload('25fd0372', component.options)
    }
    module.hot.accept("./mainSafetyHealthyMstPopup.vue?vue&type=template&id=25fd0372", function () {
      api.rerender('25fd0372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyMstPopup.vue"
export default component.exports